import { Boundaries } from "@planzone/core";
import { Identifiable, Event } from "@planzone/dto";

function handleRemoveTagRequest(
  event: Identifiable<Event>,
  { removableId, tag }: Boundaries["removeTag"]["request"],
): Identifiable<Event> {
  return event.uuid === removableId
    ? {
        ...event,
        tags: event.tags.filter(({ name }) => name !== tag.name),
      }
    : event;
}

function handleRemoveTagSuccess(
  event: Identifiable<Event>,
  { removableId, tag }: Boundaries["removeTag"]["success"],
): Identifiable<Event> {
  return event.uuid === removableId
    ? {
        ...event,
        tags: event.tags.filter(({ name }) => name !== tag.name),
      }
    : event;
}

function handleRemoveTagFailure(
  event: Identifiable<Event>,
  { removableId, tag }: Boundaries["removeTag"]["failure"],
): Identifiable<Event> {
  return event.uuid === removableId
    ? {
        ...event,
        tags: event.tags ? [...event.tags, tag] : [tag],
      }
    : event;
}

export {
  handleRemoveTagRequest,
  handleRemoveTagSuccess,
  handleRemoveTagFailure,
};
